import { render, staticRenderFns } from "./SecondLiveActivity.vue?vue&type=template&id=4630f090&scoped=true"
import script from "./SecondLiveActivity.vue?vue&type=script&lang=js"
export * from "./SecondLiveActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4630f090",
  null
  
)

export default component.exports